export interface LLTTFInvitations {
    id: string,
    cohortName: string,
    programId: number,
    organizationId: string,
    facilitatorId: number,
    noOfParticipants: number,
    programStartDate: Date | null
    linkExpiryDate: Date | null,
    isActive: boolean,
    isLoggedInUserFacilitator:boolean,
    languageId: number
}

export function LLTTFInvitationsDefaultValue(): LLTTFInvitations {
    return {
        id: '',
        cohortName: '',
        programId: 0,
        organizationId: '',
        facilitatorId: 0,
        noOfParticipants: 0,
        programStartDate: null,
        linkExpiryDate: null,
        isActive: true,
        isLoggedInUserFacilitator:false,
        languageId: 1
    }
}

export interface LLTTFInvitationView {
    cohortName: string,
    organization: string,
    facilitator: string,
    participantLimit: number,
    currentEnrollment: number,
    programStartDate: string,
    inviteExpiryDate: string,
    inviteLink: string,
    enrollments: any[],
    status: string,
    statusDescription: string,
    isDeleteEnabled:boolean
}

export function LLTTFInvitationViewDefaultValues():LLTTFInvitationView
{
    return {
        cohortName: '',
        organization: '',
        facilitator: '',
        participantLimit: 0,
        currentEnrollment: 0,
        programStartDate: '',
        inviteExpiryDate: '',
        inviteLink: '',
        enrollments: [],
        status:'',
        statusDescription:'',
        isDeleteEnabled:false 

    }
}

export interface LLTTFParticipantEmailVerificationModel{
    email: string,
    invitationGuid: string,
}

export function LLTTFParticipantEmailModelDefaultValue():LLTTFParticipantEmailVerificationModel
{
    return {email:'',invitationGuid:''}
}